import { useEffect, useState } from 'react';
import { useSocket } from '../../../contexts/SocketContext';
import { fetchAddressSettings } from '../../models/customer/addressSettingsModel';
export function useAddressSettings() {
  const { socket } = useSocket();
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let alive = true;
    let sequence = 0;
    const reload = async () => {
      const current = ++sequence;
      try { const next = await fetchAddressSettings(); if (alive && sequence === current) { setSettings(next); setError(''); } }
      catch (e) { if (alive && sequence === current) setError(e.message); }
    };
    reload();
    socket?.on('customers:address_settings_changed', reload);
    socket?.on('connect', reload);
    return () => { alive = false; socket?.off('customers:address_settings_changed', reload); socket?.off('connect', reload); };
  }, [socket]);
  return { settings, error };
}
